import Axios from 'axios'
import {facilityCurrencyUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_currencies (context) {
    Axios.get(facilityCurrencyUrls.getAllFacilityCurrencies).then(function (response) {
      context.commit('GET_ALL_FACILITY_CURRENCIES', response.data)
    })
  },
  get_facility_currencies (context, publicId) {
    Axios.get(facilityCurrencyUrls.getFacilityCurrencies + publicId).then(function (response) {
      context.commit('GET_FACILITY_CURRENCIES', response.data)
    })
  },
  get_deleted_facility_currencies (context) {
    Axios.get(facilityCurrencyUrls.getDeletedFacilityCurrency).then(function (response) {
      context.commit('GET_DELETED_FACILITY_CURRENCIES', response.data)
    })
  },
  get_facility_currency (context, publicId) {
    Axios.get(facilityCurrencyUrls.getFacilityCurrency + publicId).then(function (response) {
      context.commit('GET_FACILITY_CURRENCY', response.data)
    })
  },
  post_facility_currency (context, data) {
    Axios.post(facilityCurrencyUrls.postFacilityCurrency, data).then(function () {
      context.dispatch('get_all_facility_currencies')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_facility_currency (context, data) {
    Axios.post(facilityCurrencyUrls.postFacilityCurrency, data).then(function () {
      context.dispatch('get_all_facility_currencies')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_facility_currency (context, publicId) {
    Axios.get(facilityCurrencyUrls.deleteFacilityCurrency + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_FACILITY_CURRENCIES', response.data)
      router.push({
        name: 'Module.DeletedFacilityCurrencies'
      })
    })
  },
  restoreFacilityCurrency (context, publicId) {
    Axios.get(facilityCurrencyUrls.restoreFacilityCurrency + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_CURRENCIES', response.data)
      router.push({
        name: 'Module.FacilityCurrencies'
      })
    })
  }
}
